import styled from 'styled-components';

import colors from 'themes/Main';

const { gray01, gray03, gray05 } = colors;

export const Textarea = styled.textarea`
  max-width: 100%;
  min-width: ${({ fieldWidth }) => `${fieldWidth}%`};
  min-height: ${({ fieldHeight }) => `${fieldHeight}px`};
  padding: 16px;
  background-color: transparent;
  color: ${gray01};
  border: 1px solid ${gray03};
  border-radius: 5px;

  &::placeholder {
    color: ${gray05};
  }
`;
